// Function to filter users based on search input
export const usersFilter = (data, search) => {
  const lowerCaseSearch = search.toLowerCase();
  return data.filter(
    ({ name, email, phone }) =>
      (name && name.toLowerCase().includes(lowerCaseSearch)) ||
      (email && email.toLowerCase().includes(lowerCaseSearch)) ||
      (phone && phone.toLowerCase().includes(lowerCaseSearch)),
  );
};

// Mapping for Excel header cells to user properties
export const excelHeaderCellsName = {
  "المعرف": "id",
  "الاسم": "name",
  "الهاتف": "phone",
  "البريد الإلكتروني": "email",
};
